import React, { useEffect, useState } from "react"
import "../../../styles/tellus-starter.scss"
import "../../../styles/tellus-starter.css"
import Slider from "rc-slider"
import { Input, List } from "reactstrap"
import { RATING_BOXES, checkAccess, checkAccessed, getImageUrl } from "../../../helper"
import WritingTips from "../../../asst/writting-tips.svg"
import { Modal, ModalHeader, ModalBody } from "reactstrap"
import 'bootstrap/dist/css/bootstrap.min.css';
import { useLocation } from "react-router-dom";
import ReviewImage from "../../../images/review-popup-image.png"
import Cancel from "../../../asst/Cancel.svg"
import PlusImage from "../../../asst/Plus-more-pics.svg"

export default function NewTellUsStarter(props) {
  let {
    settings,
    attributeValue,
    setRequiredAttributes,
    setSliderValue,
    sliderValue,
    answer,
    setAnswer,
    errorAttribute,
    setErrorAttribute,
    ordersData,
    orderProductIndex,
    setAttribute,
    attributes,
    onTitleChange,
    setisTyped,
    onDescriptionChange,
    data,
    isEdit,
    starReview,
    onAttributeSelect,
    setReviewCheck,
    setAttributeAnswerMultipleValue,
    item,
    files = [],
    setFiles,
    collectSettings,
    newDiscount,
    getCurrencySymbol,
    storeCurrency,
    edit,
    setDeleteFile,
    // New props for validation
    titleError,
    setTitleError,
    descriptionError,
    setDescriptionError,
    isOnSite,
  } = props
  console.log("🚀 ~ NewTellUsStarter ~ files:", files)
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const xToken = searchParams.get("merchantId");
  console.log("🚀 ~ NewTellUsStarter ~ xToken:", xToken)
  // const [attributeValue, setAttribute] = useState([])
  const [answerss, setAnswerss] = useState([])
  const [answerss2, setAnswerss2] = useState([...answerss])
  const [activeValue, setActiveValues] = useState({})
  const [activeSingleValue, setActiveSingleValues] = useState(null)
  const [selectedOption, setSelectedOption] = useState("")
  const [modal, setModal] = useState(false)
  const [fileSizeError, setFileSizeError] = useState("")

  const toggle = () => {
    console.log("Toggle function called. Modal state before toggle:", modal)
    setModal(!modal)
  }

  // Function to calculate total file size
  const calculateTotalFileSize = (filesList) => {
    return filesList.reduce((total, file) => {
      return total + (file.size || 0)
    }, 0)
  }

  // Function to format file size for display
  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  // Function to validate file size
  const validateFileSize = (newFiles, existingFiles) => {
    const allFiles = [...existingFiles, ...newFiles]
    const totalSize = calculateTotalFileSize(allFiles)
    const maxSize = 100 * 1024 * 1024 // 100MB in bytes

    if (totalSize > maxSize) {
      const currentSize = formatFileSize(totalSize)
      setFileSizeError(`Files size exceeded 100mb limit. Please remove some files or choose smaller ones.`)
      return false
    }

    setFileSizeError("")
    return true
  }

  const setAttributes = (attribute, answer, isMultiple = false) => {
    console.log("attributeValue", attribute)
    console.log(answer, "thisissetting")
    console.log(data.attributes, "thisissettingattributes")
    console.log(attributes, "this Is attributes side")
    console.log(attributeValue, "this Is attributeValue side")
    console.log(onDescriptionChange, "onDescriptionChangeonDescriptionChange")

    if (isMultiple) {
      const attributeIndex = attributeValue.findIndex(
        (item) => item._id === attribute._id
      )

      if (attributeIndex !== -1) {
        // Attribute already exists, so add to its selectedAnswer array if it's not already present
        const existingAnswers = attributeValue[attributeIndex].selectedAnswer
        const answerExists = existingAnswers.some(
          (ans) => ans._id === answer._id
        )

        if (!answerExists) {
          attributeValue[attributeIndex].selectedAnswer.push(answer)
        } else {
          attributeValue[attributeIndex].selectedAnswer =
            existingAnswers.filter((ans) => ans._id !== answer._id)
        }
      } else {
        attributeValue.push({
          ...attribute,
          selectedAnswer: [answer],
        })
      }
    } else {
      if (
        attributeValue.findIndex((item) => item._id === attribute._id) !== -1
      ) {
        attributeValue.splice(
          attributeValue.findIndex((item) => item._id === attribute._id),
          1
        )
      }
      attributeValue.push({ ...attribute, selectedAnswer: answer })
      if (attributeValue) {
        console.log(attributeValue, "selectedAnswerAnswer")
      }
      if (attributeValue.selectedAnswer && attributeValue.widgetType === 6) {
        setAttributeAnswerMultipleValue(false)
      }
    }
    setAttribute(attributeValue)
    setRequiredAttributes(false)
    onAttributeSelect(attributeValue)
    console.log("attributeValue--->", attributeValue)
  }

  const getDiscountText = () => {
    if (collectSettings?.discounts?.offerDiscount === "reviewRequest" && isOnSite === true) {
      return `Share ${collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "true" ? "Photos/Videos" : collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "false" ? "Videos" : "Photos"} & Help Others`
    }
    const photoDiscount = collectSettings?.discounts?.discountForPhotoReview;
    const videoDiscount = collectSettings?.discounts?.discountForVideoReview;
    const bothEnabled = collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "true";

    // Check if both discounts are the same value and type
    const sameDiscount = bothEnabled &&
      photoDiscount?.value === videoDiscount?.value &&
      photoDiscount?.typeOfDiscount === videoDiscount?.typeOfDiscount;

    if (sameDiscount) {
      const discountValue = photoDiscount?.value;
      const discountSymbol = photoDiscount?.typeOfDiscount === "perc" ? "%" : getCurrencySymbol(storeCurrency) ?? "";
      return `Share Photo/Video & Get ${discountValue}${discountSymbol} Off `;
    }

    return `Share ${bothEnabled ? `Photos for ${photoDiscount?.value
      }${photoDiscount?.typeOfDiscount === "perc" ? "%" : getCurrencySymbol(storeCurrency) ?? ""} & Videos for ${videoDiscount?.value
      }${videoDiscount?.typeOfDiscount === "perc" ? "%" : getCurrencySymbol(storeCurrency) ?? ""}` : collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "false" ? `Videos for ${videoDiscount?.value
        }${videoDiscount?.typeOfDiscount === "perc" ? "%" : getCurrencySymbol(storeCurrency) ?? ""}` : `Photos for ${photoDiscount?.value
        }${photoDiscount?.typeOfDiscount === "perc" ? "%" : getCurrencySymbol(storeCurrency) ?? ""}`} Off `
  }


  useEffect(() => {

    if (attributes && isEdit) {
      attributes?.map((item) => {
        if (item.widgetType === 2) {
          console.log("herjkhekrj", item)
          setAttributes(
            item,
            {
              value: item?.selectedAnswer?.value,
              label: item?.selectedAnswer?.label,
            },
            false
          )
        }
        if (item.widgetType === 3) {
          console.log("herjkhekrj", item)
          setAttributes(
            item,
            {
              value: item?.selectedAnswer?.value,
              label: item?.selectedAnswer?.label,
            },
            false
          )
          setActiveSingleValues(item?.selectedAnswer?.value)
        }
        if (item.widgetType === 6) {
          console.log("herjkhekrj111", item)
          let indexes = []
          item?.selectedAnswer?.map((subItem) => {
            console.log("herjkhekrj11122", subItem)
            let index = item?.answers?.findIndex(
              (item) => item?.value === subItem?.value
            )
            console.log("herjkhekrj11122", index)
            indexes.push(index)
            setAttributes(item, subItem, true)
          })
          console.log("herjkhekrj11122final", indexes)
          setAnswerss2(indexes)
        }
        if (item.widgetType === 7) {
          console.log("herjkhekrjwqwq1321", item?.selectedAnswer)
          setSelectedOption(item?.selectedAnswer?.value)
          setAttributes(
            item,
            {
              value: item?.selectedAnswer?.value,
              label: item?.selectedAnswer?.value,
            },
            false
          )
        }
        if (item.widgetType === 8) {
          console.log("herjkhekrjwqwq", item?.selectedAnswer)
          setActiveValues((prev) => ({
            ...prev,
            [item?._id]: item?.selectedAnswer?.value,
          }))
          setAttributes(
            item,
            {
              value: item?.selectedAnswer?.value,
              label: item?.selectedAnswer?.label,
            },
            false
          )
        }
      })
    }

  }, [attributes])


  console.log(data?.item?.title, "data?.item?.title")
  return (
    <>
      <div style={{ position: "relative" }} className="rcf-modal-open">
        {xToken === "shoeboxpk.myshopify.com" ? "" : (
          <>
            <div>
              <input
                className={`input-field-rcf-review rcf-title-input ${titleError ? "error" : ""}`}
                name="title"
                type="text"
                style={{ color: settings?.fontColor ?? "#000" }}
                value={data?.title}
                placeholder={`${settings?.reviewPageTitle?.text ?? "Give your review a title"
                  }`}
                onChange={(e) => {
                  setisTyped(true)
                  const inputValue = e.target.value
                  console.log("e.target.value====here", e.target.value == "", inputValue)
                  if (inputValue.length > 60) {
                    // Truncate the input if it exceeds 30 characters
                    e.target.value = inputValue.slice(0, 60)
                  } else {

                  }
                  // Clear title error when user starts typing
                  if (titleError && inputValue.trim() !== "") {
                    setTitleError(false)
                  }
                  onTitleChange(e)
                }}
              ></input>

              {/* <div className="description-rcf-text">
                <p className="text-field-count">
                  {data?.title?.length ?? 0}
                  /60
                </p>
              </div> */}
            </div>
            <div
              style={{ position: "absolute", top: "10px", right: "10px" }}
              onClick={toggle}
            >
              <img src={WritingTips} alt="WritingTips" />
            </div>
          </>
        )}
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>
            <div className="d-flex gap-2">
              <img src={WritingTips} alt="WritingTips" />
              <div className="writing-res-tips">Writing Tips</div>
            </div>
          </ModalHeader>
          <ModalBody>
            <div>
              <div style={{ marginLeft: "3px", fontSize: "20px" }}>&#9989; Do</div>
              <div style={{ marginTop: "3px", color: "#464646" }}>
                <List>
                  <li>Share your honest experience—good, bad, or neutral.</li>
                  <li>Be helpful for others considering the product.</li>
                  <li>Highlight specific details about the product value.</li>
                  <li>Use examples to add clarity to your feedback.</li>
                  <li>Keep it concise, focused, and easy to read.</li>
                </List>
              </div>

              <div style={{ marginLeft: "3px", fontSize: "20px" }}>&#x274C; Don't</div>
              <div style={{ marginTop: "3px", color: "#464646" }}>
                <List>
                  <li>Use inappropriate or offensive language.</li>
                  <li>Add unrelated links or promotions.</li>
                  <li>Include sensitive personal information.</li>
                  <li>Make exaggerated or false claims.</li>
                  <li>Copy content from other reviews.</li>
                </List>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>

      {/* <p>{starReview && "Please enter title"}</p> */}
      <div className="textarea-main-div">
        {ordersData ? (
          <textarea
            name="tellus"
            id="tellus-starter"
            cols="30"
            rows="10"
            className={`input-field-rcf-description ${errorAttribute || descriptionError ? "error" : ""
              }`}
            style={{ color: settings?.fontColor ?? "#000" }}
            value={data?.description}
            placeholder={
              settings?.description?.text
                ? settings?.description?.text?.replace("{product_name}", "") +
                `${settings?.description?.text?.includes("{product_name}") &&
                  item &&
                  item?.title
                  ? item?.title
                  : ``
                }`
                : `Share your feedback about ${item
                  ? ordersData[0]?.products[orderProductIndex - 1]?.title
                  : ordersData[0]?.products[orderProductIndex - 1]?.title
                }`
            }
            onChange={(e) => {
              setisTyped(true)
              const inputValue = e.target.value
              if (inputValue.length > 500) {
                // Truncate the input if it exceeds 500 characters
                e.target.value = inputValue.slice(0, 500)
              } else {
                if (inputValue.length > 0) {
                  setReviewCheck(true)
                } else if (inputValue === "") {
                  setReviewCheck(false)
                }
                // Clear description error when user starts typing
                if (descriptionError && inputValue.trim() !== "") {
                  setDescriptionError(false)
                }
                onDescriptionChange(e)
                setErrorAttribute(false)
              }
            }}
          ></textarea>
        ) : (
          <textarea
            name="tellus"
            id="tellus-starter"
            cols="30"
            rows="10"
            className={`input-field-rcf-description ${errorAttribute || descriptionError ? "error" : ""
              }`}
            style={{ color: settings?.fontColor ?? "#000" }}
            placeholder={
              settings?.description?.text
                ? settings?.description?.text?.replace("{product_name}", "") +
                `${settings?.description?.text?.includes("{product_name}") &&
                  data &&
                  data?.item?.title
                  ? data?.item?.title
                  : ``
                }`
                : `Share your feedback about ${data ? data?.item?.title : data?.item?.title
                }`
            }
            onChange={(e) => {
              setisTyped(true)
              const inputValue = e.target.value
              if (inputValue.length > 500) {
                // Truncate the input if it exceeds 500 characters
                e.target.value = inputValue.slice(0, 500)
              } else {
                if (inputValue.length > 0) {
                  setReviewCheck(true)
                } else if (inputValue === "") {
                  setReviewCheck(false)
                }
                // Clear description error when user starts typing
                if (descriptionError && inputValue.trim() !== "") {
                  setDescriptionError(false)
                }
                onDescriptionChange(e)
                setErrorAttribute(false)
              }
            }}
          ></textarea>
        )}
        <div className="description-rcf-text">
          <p className="text-field-count">
            {data?.description?.length ?? 0}
            /500
          </p>
        </div>
      </div>
      {files.length < 1 && (collectSettings?.videoReviews?.show === "true" || collectSettings?.photoReviews?.show === "true") ? (
        <label htmlFor="share-img1">
          <div
            className="rcf-picture-uploader"
            style={{
              color: settings?.fontColor ?? "#000",
              "--rate-background":
                settings?.backgroundColor ?? "#fff",
            }}
          >

            <div className="img-rfc-main-div-upload">
              <div className="share-section">
                <div
                  className="share-img"
                  style={{
                    color: settings?.fontColor ?? "#000",
                  }}
                >
                  <input
                    style={{ display: "none" }}
                    type="file"
                    name="share"
                    id="share-img1"
                    accept={checkAccessed("videoReviews") && collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "true" ? "image/*,video/*" : checkAccessed("videoReviews") && collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "false" ? "video/*" : "image/*"}
                    multiple
                    onChange={(e) => {
                      const newFiles = Array.from(e.target.files)

                      setFiles((prevFiles) => {
                        // Check if adding new files would exceed 5 file limit
                        if (prevFiles.length + newFiles.length > 5) {
                          setFileSizeError("You can upload up to 5 files maximum.")
                          return prevFiles
                        }

                        // Validate total file size
                        if (validateFileSize(newFiles, prevFiles)) {
                          return [...prevFiles, ...newFiles]
                        } else {
                          return prevFiles
                        }
                      })

                      // Clear the input value to allow re-selecting the same files
                      e.target.value = ''
                    }}
                  />
                  <span
                    className="img-uploader-text"
                    style={{
                      color: settings?.fontColor ?? "#000",
                      textTransform:
                        xToken === "conatural.myshopify.com" || "adxee-gear.myshopify.com"
                          ? "none"
                          : "capitalize",

                    }}
                  >
                    {collectSettings?.discounts
                      ?.typeOfDiscount === "no" ||
                      !collectSettings?.discounts
                        ?.typeOfDiscount || (collectSettings?.discounts
                          ?.typeOfDiscount && checkAccessed("discountCode") === false)
                      ? `Share ${collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "true" ? "Photos/Videos" : collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "false" ? "Videos" : "Photos"} & Help Others`
                      : getDiscountText()}
                  </span>
                  <p
                    className="upload-img-span-tag"
                  // style={{
                  //   color: settings?.fontColor ?? "#000",
                  // }}
                  >

                    {collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "true" ? "Upload jpg, jpeg, png or mp4(5 files, max. 100MB)" : collectSettings?.videoReviews?.show === "true" && collectSettings?.photoReviews?.show === "false" ? "Upload mp4(5 files, max. 100MB)" : "Upload jpg, jpeg, png(5 files, max. 100MB)"}

                  </p>
                </div>
              </div>
            </div>
          </div>
        </label>
      ) : (files.length > 0 ?
        <div
          className="rcf-picture-uploader"
          style={{
            color: settings?.fontColor ?? "#000",
            "--rate-background":
              settings?.backgroundColor ?? "#fff",
          }}
        >



          {files && Array.isArray(files) && files.map((file, index) => {
            console.log("🚀 ~ {files.map ~ file:", file)
            return (
              <div className="added-img" key={index}>
                <div className="img-info">
                  {file.type?.startsWith("video/") ? (
                    <video
                      src={
                        edit && file?.mediaType !== 2
                          ? getImageUrl(file?.name)
                          : URL?.createObjectURL(file)
                      }
                      alt={`review ${index + 1}`}
                      className="uplaod-content-rcf"
                    />
                  ) : (
                    <div className="new-rcf-seen-uploader">
                      <img
                        className="rcf-new-image-upload uplaod-content-rcf"
                        key={index}
                        src={
                          edit && file?.mediaType === 2
                            ? getImageUrl(file?.name)
                            : URL?.createObjectURL(file) ??
                            ReviewImage
                        }
                        alt={`review ${index + 1}`}
                      />
                    </div>
                  )}
                </div>
                <div
                  className="seenImage-cancel-cross"
                  onClick={() => {
                    setFiles((prevFiles) => {
                      const fileToDelete = prevFiles.find(
                        (prevFile) =>
                          prevFile.name === file.name
                      )
                      console.log(
                        "🚀 ~ setFiles ~ fileToDelete:",
                        fileToDelete
                      )
                      if (fileToDelete) {
                        setDeleteFile((prevDeletedFile) => {
                          const updatedDeletedFiles =
                            prevDeletedFile
                              ? [
                                ...prevDeletedFile,
                                fileToDelete._id,
                              ]
                              : [fileToDelete._id]
                          return updatedDeletedFiles
                        })
                      }
                      const updatedFiles = prevFiles.filter((prevFile) => {
                        return prevFile.name !== file.name
                      })

                      // Re-validate file size after removal
                      const totalSize = calculateTotalFileSize(updatedFiles)
                      const maxSize = 100 * 1024 * 1024 // 100MB in bytes
                      if (totalSize <= maxSize) {
                        setFileSizeError("")
                      }

                      return updatedFiles
                    })
                  }}
                >
                  <img
                    src={Cancel}
                    className={` ${file?.type?.startsWith("video/")
                      ? "video-cancel"
                      : ""
                      }`}
                    alt="SeenImage"
                  />
                </div>
              </div>
            )
          })}
          {files.length < 5 && (
            <div className="">
              <div className="share-img">
                <input
                  style={{ display: "none" }}
                  type="file"
                  name="share"
                  id="share-img4"
                  accept={checkAccessed("videoReviews") ? "image/*,video/*" : "image/*"}

                  multiple
                  onChange={(e) => {
                    console.log("asjdhd", e.target.files)
                    const newFiles = Array.from(e.target.files)

                    setFiles((prevFiles) => {
                      // Check if adding new files would exceed 5 file limit
                      if (prevFiles.length + newFiles.length > 5) {
                        setFileSizeError("You can upload up to 5 files maximum.")
                        return prevFiles
                      }

                      // Validate total file size
                      if (validateFileSize(newFiles, prevFiles)) {
                        return [...prevFiles, ...newFiles]
                      } else {
                        return prevFiles
                      }
                    })

                    // Clear the input value to allow re-selecting the same files
                    e.target.value = ''
                  }}
                />
                <label htmlFor="share-img4">
                  <div className="upload-more-btn">
                    Upload More
                  </div>
                </label>
              </div>
            </div>)}
        </div> : ""
      )}
      {/* {files.length > 0 && (
        <p className="file-size-info" style={{ color: "#666", fontSize: "12px", margin: "5px 0" }}>
          Total size: {formatFileSize(calculateTotalFileSize(files))} / 100MB ({files.length}/5 files)
        </p>
      )} */}
      <p className="error-description" style={{ color: "red" }}>
        {files.length > 5 && "You can upload up to 5 files"}
        {fileSizeError && fileSizeError}
      </p>
      <div
        className="rcf-tell-us-container"
        style={{
          color: settings?.fontColor ?? "#000",
          "--rate-background": settings?.SelectionColor ?? "#fff",
          "--select-hover-color": settings?.SelectionColor ?? "#0ABAAF",
          "--primary-color": settings?.SelectionColor ?? "#0ABAAF",
          "--select-background-color": settings?.SelectionColor ?? "#0ABAAF",
          "--select-font-color": settings?.SelectionFontColor ?? "#fff",
          "--font-color": settings?.fontColor ?? "#000",
        }}
      >
        <div
          className="tell-us-popup-content"
          style={{ width: "100% important" }}
        >
          <div
            className="textarea-details"
            style={{
              color: settings?.fontColor ?? "#000",
            }}
          >
            {checkAccess(
              "attributeRatings",
              <div className="extra-details tell-us-new-rcf">
                {attributes?.map((attribute) => {
                  //recomend product type 2
                  if (attribute?.widgetType === 2) {
                    return (
                      <div className="health-concerns" style={{marginTop: "20px"}}>
                        <p
                          className="description recommended-products-heading"
                          style={{
                            color: settings?.fontColor ?? "#000",
                          }}
                        >
                          {attribute?.question}
                          <span
                            style={{
                              color: settings?.fontColor ?? "#000",
                            }}
                          >
                            {attribute?.required && "*"}
                          </span>
                          <span className="single-choose-select">Choose 1</span>
                        </p>
                        <div
                          className="health-buttons my-rcf-selected-div"
                          style={{
                            color: settings?.fontColor ?? "#000",
                          }}
                        >
                          {[
                            { label: "Yes", value: "Yes" },
                            { label: "No", value: "No" },
                          ]?.map((ans) => (
                            <button
                              className={`select-btn-rcf ${ans.value === answer[attribute?.widgetType]
                                ? "active"
                                : ""
                                }`}
                              onClick={() => {
                                setAttributes(attribute, ans, false)
                                setAnswer({
                                  ...answer,
                                  [attribute?.widgetType]: ans.value,
                                })
                              }}
                            >
                              {ans.value}
                            </button>
                          ))}
                        </div>
                      </div>
                    )
                  }
                  //========================Number Selection =============
                  else if (attribute?.widgetType === 3) {
                    return (
                      <div
                        className="effectiveness-helpful number-selection-main-div"
                        style={{ width: "100%" }}
                      >
                        <div className="effectiveness" style={{ width: "100%" }}>
                          <span
                            className="description recommended-products-heading new-rcf-main-heading"
                            style={{
                              color: settings?.fontColor ?? "#000",
                            }}
                          >
                            {attribute?.question}
                            <span
                              style={{
                                color: settings?.fontColor ?? "#000",
                                fontSize: "16px",
                              }}
                            >
                              {attribute?.required && "*"}
                            </span>
                          </span>
                          <span className="single-choose-select">Choose 1</span>
                          <div
                            className="effectiveness-no"
                            style={{
                              width: "100%",
                            }}
                          >
                            {RATING_BOXES?.map((item) => (
                              <span
                                onClick={() => {
                                  console.log(
                                    "color======",
                                    settings?.SelectionFontColor ?? "#000",
                                    "backgroundColor======",
                                    item.value === answer[attribute?.widgetType]
                                      ? settings?.SelectionColor
                                      : "#fff",
                                    "border=====",
                                    item.value === answer[attribute?.widgetType]
                                      ? settings?.SelectionColor
                                      : ""
                                  )
                                  setAttributes(attribute, item, false)
                                  setAnswer({
                                    ...answer,
                                    [attribute?.widgetType]: item.value,
                                  })
                                  setActiveSingleValues(item.value)
                                }}
                                // className={`select-choice-btn-rcf c-pointer effectiveness-item ${
                                //   answer[attribute?.widgetType] === item.value
                                //     ? "active"
                                //     : ""
                                // }`}
                                className={`select-choice-btn-rcf c-pointer effectiveness-item ${activeSingleValue === item.value ? "active" : ""
                                  }`}
                                style={{}}
                                key={item.value}
                              >
                                {item.label}
                              </span>
                            ))}
                          </div>
                          <div
                            className="rcf-heading-optins"
                            style={{
                              color: settings?.fontColor ?? "#000",
                            }}
                          >
                            <span className="rcf-heading-optins">
                              {attribute?.answers?.[0]?.label}
                            </span>
                            <span className="rcf-heading-optins">
                              {attribute?.answers?.[1]?.label}
                            </span>
                          </div>
                        </div>
                      </div>
                    )
                  }
                  //===================Option Bar WidgetType4=======
                  else if (attribute?.widgetType === 4) {
                    return (
                      <div className="attribute-five attribute-five-new-rcf">
                        <div>
                          <p
                            className="description recommended-products-heading new-rcf-main-heading"
                            style={{
                              color: settings?.fontColor ?? "#000",
                            }}
                          >
                            {attribute?.question}
                            <span
                              style={{
                                color: settings?.fontColor ?? "#000",
                              }}
                            >
                              {attribute?.required && "*"}
                            </span>
                            <span className="single-choose-select">Choose 1</span>
                          </p>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                            }}
                          >
                            <Slider
                              className="slider-new-rcf"
                              min={0}
                              defaultValue={null}
                              marks={{
                                0: attribute?.answers?.[0]?.label,
                                50: attribute?.answers?.[1]?.label,
                                100: attribute?.answers?.[2]?.label,
                              }}
                              step={50}
                              included={false}
                              value={sliderValue}
                              // ref={sliderRef}
                              onChange={(value, label) => {
                                // Your onChange logic here
                                if (value === 0) {
                                  value = attribute?.answers?.[0]?.value
                                  label = attribute?.answers?.[0]?.label
                                }
                                if (value === 50) {
                                  value = attribute?.answers?.[1]?.value
                                  label = attribute?.answers?.[1]?.label
                                }
                                if (value === 100) {
                                  value = attribute?.answers?.[2]?.value
                                  label = attribute?.answers?.[2]?.label
                                }

                                console.log(value, "asdasdasd")

                                console.log("attribute---?", value)
                                setAttributes(
                                  attribute,
                                  { value: value, label: label },
                                  false
                                )
                                setSliderValue(value)
                              }}
                              style={{
                                background:
                                  attribute?.value ===
                                    attribute?.answers?.[1]?.value
                                    ? "#ccc"
                                    : undefined,
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  }
                  //=================center-Option_bar==============
                  else if (attribute?.widgetType === 5) {
                    return (
                      <div
                        className="attribute-four"
                        style={{
                          padding: "0 0 30px 0px",
                        }}
                      >
                        <div>
                          <p
                            className="description recommended-products-heading new-rcf-main-heading"
                            style={{ color: settings?.fontColor ?? "#000" }}
                          >
                            <span
                              style={{
                                color: settings?.fontColor ?? "#000",
                              }}
                            ></span>
                            {attribute?.question}
                            {attribute?.required && "*"}
                            <span className="single-choose-select">Choose 1</span>
                          </p>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <Slider
                              className="center-bar-new-rcf"
                              style={{ width: "96% !important" }}
                              min={0}
                              defaultValue={null}
                              marks={{
                                0: attribute?.answers?.[0]?.label,
                                50: attribute?.answers?.[1]?.label,
                                100: attribute?.answers?.[2]?.label,
                              }}
                              step={50}
                              included={false}
                              // value={sliderValue}
                              onChange={(value, label) => {
                                if (value === 0) {
                                  value = attribute?.answers?.[0]?.value
                                  label = attribute?.answers?.[0]?.label
                                }
                                if (value === 50) {
                                  value = attribute?.answers?.[1]?.value
                                  label = attribute?.answers?.[1]?.label
                                }
                                if (value === 100) {
                                  value = attribute?.answers?.[2]?.value
                                  label = attribute?.answers?.[2]?.label
                                }
                                setAttributes(
                                  attribute,
                                  {
                                    value: value,
                                    label: label,
                                  },
                                  false
                                )
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    )
                  }
                  // =====================Mutiple Selection ====================
                  else if (attribute?.widgetType === 6) {
                    return (
                      <div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <p
                            className="recommended-products-heading new-rcf-main-heading"
                            style={{
                              color: settings?.fontColor ?? "#000",
                            }}
                          >
                            {" "}
                            {attribute?.question}
                            <span>{attribute?.required && "*"}</span>
                          </p>
                          <div style={{ paddingTop: "8px" }}>
                            <span className="single-choose-select">
                              Choose 1 or more
                            </span>
                          </div>
                        </div>
                        <div className="rcf-div-multi-option">
                          {attribute?.answers?.map((answers, index) => (
                            <button
                              key={index}
                              className={`select-multi-btn-rcf ${answerss2?.includes(answers?._id) ? "active" : ""
                                }`}
                              onClick={() => {
                                console.log("asdasda", answers)
                                setAttributes(attribute, answers, true)
                                if (answerss2?.includes(answers?._id)) {
                                  answerss2.splice(answerss2.indexOf(answers?._id), 1)
                                } else answerss2.push(answers?._id)
                                console.log("asdasdaanswerss2", answerss2)
                                setAnswerss(answerss2)
                                setAnswer({
                                  ...answer,
                                  [attribute?.widgetType]: answers.value,
                                })
                                setAnswerss("")
                                console.log(
                                  "indexx==",
                                  answerss2?.includes(index)
                                )
                                console.log("multi=>", answerss2)
                              }}
                            >
                              {answers.value}
                            </button>
                          ))}
                        </div>
                      </div>
                    )
                  } else if (attribute?.widgetType === 7) {
                    return (
                      <div
                        className="gender"
                        style={{
                          color: settings?.fontColor ?? "#000",
                        }}
                      >
                        <label
                          className="recommended-products-heading new-rcf-main-heading"
                          htmlFor="dropdown"
                        >
                          <span
                            style={{
                              color: settings?.fontColor ?? "#000",
                            }}
                          ></span>
                          {attribute?.question}
                          {attribute?.required && "*"}
                        </label>
                        <span className="single-choose-select">Choose 1</span>
                        <Input
                          className="dropDown-select"
                          type="select"
                          name="drop"
                          id="dropdowm"
                          value={selectedOption}
                          style={{ color: settings?.fontColor ?? "#000" }}
                          onChange={(e) => {
                            const selectedValue = e.target.value
                            setSelectedOption(selectedValue)
                            attribute.selectedAnswer = selectedValue
                            setAttributes(
                              attribute,
                              {
                                value: e.target.value,
                                label: e.target.value,
                              },
                              false
                            )
                          }}
                        >
                          <option
                            disabled
                            value=""
                            selected
                            className="dropdown-selected-new-rcf"
                          >
                            Choose Option
                          </option>
                          {attribute?.answers?.map((answer) => (
                            <option value={answer.value}>{answer.label}</option>
                          ))}
                        </Input>
                      </div>
                    )
                  }
                  ///=========================single select======================
                  else if (attribute?.widgetType === 8) {
                    return (
                      <div>
                        <div>
                          <label
                            className="recommended-products-heading new-rcf-main-heading"
                            style={{
                              color: settings?.fontColor ?? "#000",
                            }}
                          >
                            {attribute?.question}
                            <span
                              style={{
                                color: settings?.fontColor ?? "#000",
                              }}
                            >
                              {attribute?.required && "*"}
                            </span>
                          </label>
                          <span className="single-choose-select">Choose 1</span>
                        </div>
                        <div
                          className="rcf-div-multi-option"
                          style={{
                            color: settings?.fontColor ?? "#000",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {attribute?.answers?.map((answer) => (
                            <div className="d-flex">
                              <div style={{ paddingTop: "1px" }}>
                                <input
                                  type="radio"
                                  id={`radio-${answer.value}`}
                                  className={`input-radio-btn select-multi-btn-rcf ${activeValue === answer.value ? "active" : ""
                                    }`}
                                  name={`radio-${attribute?._id}`}
                                  value={answer?.value}
                                  checked={
                                    activeValue[attribute?._id] === answer?.value
                                  }
                                  onChange={() => {
                                    setAttributes(
                                      attribute,
                                      {
                                        value: answer?.value,
                                        label: answer?.label,
                                      },
                                      false
                                    )
                                    // setActiveValues(answer.value)
                                    setActiveValues((prev) => ({
                                      ...prev,
                                      [attribute?._id]: answer?.value,
                                    }))
                                  }}
                                />
                              </div>
                              <label
                                style={{ paddingLeft: "20px" }}
                                htmlFor={`radio-${answer.value}`}
                              >
                                {answer?.value}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    )
                  } else return <div></div>
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
